import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"hero\" id=\"home\"><div class=\"hero__filter\"><div class=\"hero__filter-item\"></div><div class=\"hero__filter-item\"></div><div class=\"hero__filter-input\"><input type=\"text\"><div class=\"input__button\"><img src=\"/assets/images/icons/icon-search.svg\" alt=\"\"></div></div></div><div class=\"container-custom\"><div class=\"hero__content\"><div class=\"hero__content-title\">We enforce ideas</div><div class=\"hero__content-text\">Build a sustainable future</div><div class=\"hero__content-button\"><img src=\"/assets/images/icons/icon-play.svg\" alt=\"\"></div></div></div><div class=\"hero__action\"><div class=\"hero__action-item\"><img src=\"/assets/images/icons/icon-phone-red.svg\" alt=\"\"></div><div class=\"hero__action-item\"><img src=\"/assets/images/icons/icon-message-red.svg\" alt=\"\"></div></div></div>", 1)
const _hoisted_3 = {
  class: "section building",
  id: "venture"
}
const _hoisted_4 = { class: "container-custom" }
const _hoisted_5 = { class: "section__title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "section__title-content" }, "Venture Building", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "section__title-text" }, "We're the venture builders who transform good sparks into rocketships. Our fuel? Expertise, assets, and a network that ignites growth. Sustainable, risk-minimized, and fully committed – that's our launchpad. Ready to blast off? Partner with us and watch your vision take flight.", -1)
const _hoisted_8 = { class: "section__title-button" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Explore our model", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icons/icon-arrow.svg",
  alt: ""
}, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "section__card" }
const _hoisted_14 = { class: "section__card-title" }
const _hoisted_15 = { class: "title__content" }
const _hoisted_16 = { class: "title__icon" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "section__card-text" }
const _hoisted_19 = { class: "section join" }
const _hoisted_20 = { class: "container-custom" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "section__title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section__title-content" }, "We join forces with")
], -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "section__card" }
const _hoisted_24 = { class: "section__card-title" }
const _hoisted_25 = { class: "title__content" }
const _hoisted_26 = { class: "section__card-text" }
const _hoisted_27 = { class: "section__card-icon" }
const _hoisted_28 = { class: "icon icon-large" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "icon icon-small" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  class: "section action",
  id: "model"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "container-custom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section__title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "section__title-content" }, [
      /*#__PURE__*/_createTextVNode(" Venture Building "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" what makes our model outstanding ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "section__title-text" }, "We build and scale businesses in a repeatable, efficient, and risk-minimized way, with the full commitment of our team.")
  ])
], -1)
const _hoisted_34 = { class: "action__box" }
const _hoisted_35 = { class: "item__title" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "item__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icons/icon-star.svg",
    alt: ""
  })
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "action__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/layouts/action-image-full.png",
    alt: ""
  })
], -1)
const _hoisted_38 = {
  class: "section work",
  id: "work"
}
const _hoisted_39 = { class: "container-custom" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "section__title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section__title-content" }, "We work in innovative fields")
], -1)
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "section__card" }
const _hoisted_43 = { class: "section__card-title" }
const _hoisted_44 = { class: "title__content" }
const _hoisted_45 = { class: "title__icon" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "section__card-text" }
const _hoisted_48 = {
  class: "section companies",
  id: "contact"
}
const _hoisted_49 = { class: "container-custom" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "section__title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section__title-content" }, "We build companies with ambitious professionals")
], -1)
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "companies__item" }
const _hoisted_53 = { class: "companies__item-icon" }
const _hoisted_54 = { class: "icon icon-large" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "icon icon-small" }
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "companies__item-button" }
const _hoisted_59 = {
  href: "javascript:;",
  class: "btn btn-outline"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icons/icon-arrow.svg",
  alt: ""
}, null, -1)

import router from "@/router";
import { scrollToElement } from "@/utils/util";
import { reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const state = reactive({
  listAbout: [
    { icon: 'solution', title: 'Solutions-Led', text: 'We are focused on the outcome of making our customers successful, and we prioritize their individual needs over existing products or processes.' },
    { icon: 'target', title: 'Skilled', text: 'We are experts in our industry and our markets and will continually enhance our professional skills to provide the highest standards of service to our customers.' },
    { icon: 'enlargement', title: 'Inventive', text: 'We empower and encourage our people to find creative new ways to bring success to SSI and its customers.' },
  ],
  listBuilding: [
    { icon: 'solution', title: 'Speed and efficiency', text: 'We help you bring your ideas to market quickly and effectively by leveraging our existing resources and expertise' },
    { icon: 'target', title: 'Risk reduction', text: 'We help you reduce the risk of failure by providing guidance and expertise from experienced professionals' },
    { icon: 'enlargement', title: 'Increased chances of success', text: `We help you increase your business's chances of success by providing best practices and lessons learned from other successful startups` },
  ],
  listJoin: [
    { iconLarge: 'caravat', iconSmall: 'bag', title: 'Founders', text: 'Ready to translate your vision into an empire? We fuel the rockets of ambitious founders like you. Join our launchpad and propel your startup to global orbit. Lead the charge, shape the future, and leave your mark on the world. This is your moment. Ignite it.' },
    { iconLarge: 'user-money', iconSmall: 'money', title: 'Partners', text: 'At the heart of our partners relationships lies unwavering trust, a commitment to long-term collaboration, and the agility to navigate evolving needs. We cultivate a diverse portfolio of thriving technology startups, fostering partnerships built on mutual respect and shared vision.' },
  ],
  listWork: [
    { icon: 'fintech', title: 'FinTech', text: `We aren't just FinTech builders, we're FinTech revolutionaries. With years of experience under our belt, we've crafted online payments, streamlined foreign exchange, and even redefined trading platforms.` },
    { icon: 'global', title: 'Big Data', text: 'Harnessing the power of Big Data, we craft intelligent solutions that empower you. Predict key parameters with uncanny accuracy, navigate complex business decisions with confidence, and unlock hidden insights buried within colossal data sets. We stand as your trusted partner in unlocking the full potential of your data.' },
    { icon: 'web', title: 'Web 3.0', text: `We engineer the future. We build Web 3.0 companies powered by the revolutionary trinity: blockchain, AI/ML, and VR. Decentralized finance, data ownership, and immersive experiences – these are not just words, they're the cornerstones of our creations.` },
  ],
  listAction: [
    { title: 'Innovation' },
    { title: 'Focus on sustainability' },
    { title: 'Wide range of resources' },
    { title: 'Strong network' },
    { title: 'Commitment to success' },
  ],
  listCompanies: [
    { iconLarge: 'money', iconSmall: 'user-money', text: 'Join as a Partners' },
    { iconLarge: 'caravat', iconSmall: 'bag', text: 'Join as a Founder' },
  ]
})

const handleClick = (link: string) => {
  router.replace({ name: 'Home', params: { id: link } })
  scrollToElement(link)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              href: "javascript:;",
              class: "btn btn-outline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick('model')))
            }, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.listBuilding, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-12 col-md-6 col-lg-4 mb"
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("img", {
                      src: `/assets/images/icons/icon-${item.icon}.svg`,
                      alt: ""
                    }, null, 8, _hoisted_17)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(item.text), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.listJoin, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-12 col-md-6 mb"
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(item.title), 1)
                ]),
                _createElementVNode("div", _hoisted_26, _toDisplayString(item.text), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("img", {
                      src: `/assets/images/icons/icon-${item.iconLarge}.svg`,
                      alt: ""
                    }, null, 8, _hoisted_29)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("img", {
                      src: `/assets/images/icons/icon-${item.iconSmall}.svg`,
                      alt: ""
                    }, null, 8, _hoisted_31)
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.listAction, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "action__box-item"
          }, [
            _createElementVNode("div", _hoisted_35, _toDisplayString(item.title), 1),
            _hoisted_36
          ]))
        }), 128))
      ]),
      _hoisted_37
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.listWork, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-12 col-md-6 col-lg-4 mb"
            }, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("img", {
                      src: `/assets/images/icons/icon-${item.icon}.svg`,
                      alt: ""
                    }, null, 8, _hoisted_46)
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, _toDisplayString(item.text), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _hoisted_50,
        _createElementVNode("div", _hoisted_51, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.listCompanies, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-12 col-md-6 mb"
            }, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("img", {
                      src: `/assets/images/icons/icon-${item.iconLarge}.svg`,
                      alt: ""
                    }, null, 8, _hoisted_55)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("img", {
                      src: `/assets/images/icons/icon-${item.iconSmall}.svg`,
                      alt: ""
                    }, null, 8, _hoisted_57)
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("a", _hoisted_59, [
                    _createElementVNode("span", null, _toDisplayString(item.text), 1),
                    _hoisted_60
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})